import { create } from "zustand";


interface LeftMenuState {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const useLeftMenuStore = create<LeftMenuState>((set) => ({
    isOpen: false,
    setIsOpen: (isOpen: boolean) => set((state) => ({ ...state, isOpen })),
}));

export default useLeftMenuStore;
